import React from 'react';
import AdminApp from './AdminApp';

function App() {
  return (
    <div className="App">
      <AdminApp />
    </div>
  );
}

export default App;